import script from "./SearchHotwordList.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchHotwordList.vue?vue&type=script&setup=true&lang=js"

import "./SearchHotwordList.vue?vue&type=style&index=0&id=13ce2ee4&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ce2ee4"]])

export default __exports__